import { useSyncExternalStore } from 'react';
import { getApiConnectivityStatus, subscribeApiConnectivity, type ApiConnectivityStatus } from '@/lib/api';

let cachedStatus = getApiConnectivityStatus();

function subscribe(callback: () => void): () => void {
  return subscribeApiConnectivity((status) => {
    cachedStatus = status;
    callback();
  });
}

function getSnapshot(): ApiConnectivityStatus {
  return cachedStatus;
}

export function useApiConnectivity(): ApiConnectivityStatus {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
